import React from 'react'
import styles from './GreenWall.module.css'
import Grid2 from '../Grid/grid2'
import { BannerWoodenRack } from '../Banner/BannerWoodenRack'
import { BannerWoodenCollection } from '~/components/Banner/BannerWoodenCollection'

export const WoodenRack: React.FC = () => {
  return (
    <div className={styles.page}>
      {/* HERO */}
      <BannerWoodenCollection
        href="/cdn/wooden-rack/landing.jpg"
        content={BannerWoodenRack}
      ></BannerWoodenCollection>

      <section>
        <Grid2
          images={[
            { src: '/cdn/wooden-rack/1.jpg' },
            { src: '/cdn/wooden-rack/landing.jpg' },
            { src: '/cdn/wooden-rack/3.jpg' },
            { src: '/cdn/wooden-rack/4.jpg' },
            { src: '/cdn/wooden-rack/5.jpg' },
          ]}
          href="/"
        ></Grid2>
      </section>
    </div>
  )
}
